import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as actions from '../redux/actions';
import Panel from './shared/Panel';
import { List, Button, Icon } from 'semantic-ui-react';
import { getCategories, isAuthed, getKeys } from '../redux/reducers';
import SubscriptionIntroList from './SubscriptionIntroList';

const SubscriptionSelectPanel = (props) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
//   useEffect(() => { fetchData() }, [])

//   const fetchData = async () => {
//     const keys = await props.fetchApiKey();
//     props.fetchApiCategories();
//   }

  const handleOnClick = (cat) => {
    setSelected(cat.title);
    props.handleCategorySelect(cat);
  }

  const [selected, setSelected] = useState('');

  const introduction = {id: '0', title: 'Introduction', description: ''}
  const ids = [];
  props.categories.map(cat => ids.push(Object.values(cat)[0]));
  !ids.includes("0") && props.categories.unshift(introduction);

  return (
    <Panel
      title={
        <Fragment>
          SUBSCRIPTIONS
          {/*(!props.isAuthed || props.keys.length < 1) && */<div className="api-button-div">
          <Link to="/profile" target="_blank"><Button primary className="api-button-small"><Icon name="edit" />SUBSCRIBE</Button></Link>
          </div>}
        </Fragment>
      }
    >
      <List divided relaxed className="categories-list">
        {props.categories.map(cat => <List.Item
                                        id="padded"
                                        key={cat.id}
                                        className={selected===cat.title ? "selected" : ""}
                                        active={selected===cat.title ? true : false}
                                        onClick={() => handleOnClick(cat) }>{cat.title}

                                        <div>
                                          {cat.id === "0" && <SubscriptionIntroList />}
                                        </div>
                                      </List.Item>)}
      </List>
    </Panel>
  );
};

const mapStateToProps = (state) => ({
//   categories: getCategories(state),
  isAuthed: isAuthed(state),
  keys: getKeys(state)
});

export default connect(mapStateToProps, actions)(SubscriptionSelectPanel);